import styled from 'styled-components';

export const StldRadioOptions = styled.div`
    display: flex;
    align-items: center;
    padding: 1rem 0;
`